import './common/gearboxComponents';
import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import styles from './app.module.scss';
import {
    BASE_PATH,
    CREATE_PASSWORD_PAGE,
    RESET_PASSWORD_PAGE,
    EXPIRED_PASSWORD_PAGE,
    FORGOT_PASSWORD_PAGE,
    HOME_PAGE,
    PASSWORD_CHANGED_PAGE,
} from './common/routes';
import Header from './components/header/Header';
import LoginPage from './pages/login/LoginPage';
import ForgotPasswordPage from './pages/forgotPassword/ForgotPasswordPage';
import CreatePasswordPage from './pages/forgotPassword/createPassword/CreatePasswordPage';
import ResetPasswordRouter from './pages/forgotPassword/resetPassword/ResetPasswordRouter';
import PasswordChangedPage from './pages/forgotPassword/passwordChanged/PasswordChangedPage';
import { AppContextProvider } from './components/appContext/AppContext';
import { BasicAppLayout } from './components/app-layout';

const Login: React.FunctionComponent = (): ReactElement | null => {
    return (
        <div className={styles.appBody}>
            <Header className={styles.appHeader} />
            <main className={styles.appContent}>
                <LoginPage />
            </main>
        </div>
    );
};

const OtherRoutes: React.FunctionComponent = (): ReactElement | null => {
    return (
        <BasicAppLayout baseUrl={BASE_PATH} currentPath={'/'}>
            <Header className={styles.appHeader} />
            <div className={styles.pageContent}>
                <Switch>
                    <Route path={FORGOT_PASSWORD_PAGE} component={ForgotPasswordPage} />
                    <Route path={CREATE_PASSWORD_PAGE} component={CreatePasswordPage} />
                    <Route exact path={[RESET_PASSWORD_PAGE, EXPIRED_PASSWORD_PAGE]} component={ResetPasswordRouter} />
                    <Route path={PASSWORD_CHANGED_PAGE} component={PasswordChangedPage} />
                </Switch>
            </div>
        </BasicAppLayout>
    );
};

const AppContainer: React.FunctionComponent = (): ReactElement | null => {
    return (
        <AppContextProvider>
            <Switch>
                <Route exact path={[HOME_PAGE, BASE_PATH]} component={Login} />
                <Route
                    path={[
                        FORGOT_PASSWORD_PAGE,
                        CREATE_PASSWORD_PAGE,
                        RESET_PASSWORD_PAGE,
                        PASSWORD_CHANGED_PAGE,
                        EXPIRED_PASSWORD_PAGE,
                    ]}
                    component={OtherRoutes}
                />
            </Switch>
        </AppContextProvider>
    );
};

export default AppContainer;
